import React from 'react'
import PageTitle from '../../pagetitle/PageTitle'
import Contents from '../../contents/Contents'

export default function Haberler()
{
    return (
        <>
            <PageTitle name="OKAF'24 Tüm Haberler"></PageTitle>
            <div class="container">
                <div class="singlePost my-4">
                    <Contents adet="9999"></Contents>
                </div>
            </div>
        </>
    )
}